var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Essentials/close cross/circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M13.0145 7.57109L10.5145 10.0711M10.5145 10.0711L8.01449 12.5711M10.5145 10.0711L13.0145 12.5711M10.5145 10.0711L8.01449 7.57109M18.8478 10.0711C18.8478 14.6735 15.1169 18.4044 10.5145 18.4044C5.91211 18.4044 2.18115 14.6735 2.18115 10.0711C2.18115 5.46872 5.91211 1.73776 10.5145 1.73776C15.1169 1.73776 18.8478 5.46872 18.8478 10.0711Z",
    stroke: "#D6BBFB",
    strokeWidth: 1.66667,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.5e0ed5b1c716faf2c40fe727d4ad390b.svg";
export { ForwardRef as ReactComponent };